export default {
  data: () => ({
    svg: {},

  }),
  props: {
    name: {
      type: String,
      required: true,
    },
    inline: {
      type: Boolean,
      default: true,
    },
    group: {
      type: String,
      default: '',
    },
  },
  watch: {
    name: {
      handler() {
        try {
          // eslint-disable-next-line import/no-dynamic-require,global-require
          const icon = require(`@assets/sprite/svg/${this.group ? `${this.group}/` : ''}${this.name}.svg`);
          this.svg = icon.default;
        } catch (e) {
          this.svg = {};
          this.$emit('error');
        }
      },
      immediate: true,
    },
  },
};
